// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1012":"2faed1ce","2404":"c3441671","4968":"2faed1ce","8499":"2faed1ce","9635":"2faed1ce"}[chunkId] + ".chunk.css";
};